import { Serializable } from '@admin/core/models/serializable';

export class BannerPositionModel implements Serializable<BannerPositionModel> {
  fromObject(object: any): BannerPositionModel {
    Object.assign(this, object);

    return this;
  }

  toObject() {
    return {
      BannerPositionId: this.bannerPositionId,
      HeadBannerPositionId: this.headBannerPositionId,
      Name: this.name,
      KeyName: this.keyName,
      InsertDate: this.insertDate,
      IsActive: this.isActive,
      DesktopWidth: this.desktopWidth,
      DesktopHeight: this.desktopHeight,
      ResponsiveWidth: this.responsiveWidth,
      ResponsiveHeight: this.responsiveHeight,
    };
  }

  public bannerPositionId: number;
  public headBannerPositionId: number;
  public headBannerPosition: BannerPositionModel;
  public name: string;
  public keyName: string;
  public insertDate: Date;
  public isActive: Boolean;
  public desktopWidth: string;
  public desktopHeight: string;
  public responsiveWidth: string;
  public responsiveHeight: string;

  constructor() {}
}
